import { useLocation } from 'react-router-dom';

const NotFound = () => {
  const location = useLocation();

  return (
    <div style={{
      fontFamily: 'Verdana',
      fontWeight: 'normal',
      fontSize: '.7em',
      color: 'black',
      backgroundColor: 'white',
      padding: '20px',
      direction: 'ltr',
      textAlign: 'left'
    }}>
      <h1 style={{
        fontFamily: 'Verdana',
        fontWeight: 'normal',
        fontSize: '18pt',
        color: 'red'
      }}>
        Server Error in '/prenup' Application.
        <hr style={{ width: '100%', size: 1, color: 'silver' }} />
      </h1>

      <h2 style={{
        fontFamily: 'Verdana',
        fontWeight: 'normal',
        fontSize: '14pt',
        color: 'maroon'
      }}>
        <i>The resource cannot be found.</i>
      </h2>

      <div style={{ fontFamily: 'Arial, Helvetica, Geneva, SunSans-Regular, sans-serif' }}>
        <b>Description: </b>
        HTTP 404. The resource you are looking for (or one of its dependencies) could have been removed,
        had its name changed, or is temporarily unavailable. Please review the following URL and make sure
        that it is spelled correctly.
        <br /><br />

        <b>Requested URL: </b>{location.pathname}
        <br /><br />
      </div>
    </div>
  );
};

export default NotFound;
